<!-- 出库任务单 -->
<template>
    <div>
        <!-- 按钮组 -->
        <div class="buttons_box">
            <!-- <el-button type="primary" size="mini" class="mini_button">导入</el-button> -->
            <el-button type="primary" size="mini" class="mini_button" @click="saveOutboundForm">保存</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="outboundDel" :disabled="outboundForm.id ==='' || editConfig">删除</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="completeTask" v-if="!editConfig">任务结束</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="revokeCompleteTask" v-else>撤销结束</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="IMGListExport" >图片打包导出</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="taskMainFiles" >任务单附件</el-button>
            <el-button type="warning" size="mini" class="mini_button" @click="openAiParse"  :disabled="outboundForm.id !=='' || editConfig">AI识别</el-button>

            <!-- <el-button type="primary" size="mini" class="mini_button" @click="wmsGetFlexOutReportById" >LOT号导出</el-button> -->
            <!-- <el-button type="primary" size="mini" class="mini_button" >删除</el-button> -->
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button> -->
            <!-- <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
        <el-form class="demo-form-inline outboundForm" :inline="true" ref="outboundForm" :model="outboundForm" :rules="outboundFormRules" size="mini" label-width="160px">
            <el-divider content-position="left">任务信息</el-divider>
                <el-form-item label="任务状态" prop="billStatus"> 
                    <el-input disabled v-model="outboundForm.billStatus" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="出库单号" prop="billNo"> 
                    <el-input disabled v-model="outboundForm.billNo"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="出库状态" prop="taskStatus"> 
                    <el-input disabled placeholder="" v-model="outboundForm.taskStatus"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="单证员" prop="createUser"> 
                    <el-input disabled v-model="outboundForm.createUser"  suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker disabled v-model="outboundForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width: 193px;"> </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker :disabled="editConfig" class="width_100" v-model="outboundForm.planDate" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 193px;"> </el-date-picker>
                </el-form-item>   
                <el-form-item label="备注" prop="remark">
                    <el-input :disabled="editConfig" v-model="outboundForm.remark" suffix-icon="xxxx" style="width: 558px;"> </el-input>
                </el-form-item>
                <el-divider content-position="left">货物信息</el-divider>
                <el-form-item label="账册编号" prop="handbook">
                    <el-input disabled v-model="outboundForm.handbook" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName">
                    <el-input disabled v-model="outboundForm.ckName" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded">
                    <el-input disabled v-model="outboundForm.isBonded" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="货主" prop="ownerName">
                    <el-input disabled v-model="outboundForm.ownerName" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="提货方" prop="customer">
                    <el-select :disabled="editConfig" filterable placeholder="请选择提货方" v-model="outboundForm.customer">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出库提单号" prop="blNo">
                    <el-input :disabled="editConfig" v-model="outboundForm.blNo" placeholder="请输入出库提单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="出库报关单号" prop="cusDeclNo">
                    <el-input :disabled="editConfig" v-model="outboundForm.cusDeclNo" placeholder="请输入出库报关单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="出库核注清单号" prop="invDecNo">
                    <el-input :disabled="editConfig" v-model="outboundForm.invDecNo" placeholder="请输入出库核注清单号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <!-- 核放单号：只有【七星河路仓库 + 保税】时才允许填写，其余情况禁用 -->
                <el-form-item label="核放单号" prop="checkNo">
                    <!-- 输入框+识别图标一行显示，总宽度和旁边输入框一致 -->
                    <div class="check_no_box">
                        <el-input :disabled="outboundForm.ckName !== '七星河路仓库' || outboundForm.isBonded !== '保税' || editConfig" v-model="outboundForm.checkNo" placeholder="请输入核放单号"> </el-input>
                        <el-button type="primary" icon="el-icon-upload2" size="mini" circle @click="openCheckReleaseParse" class="check_no_icon"></el-button>
                    </div>
                </el-form-item>
                <el-form-item label="出库申报日期" prop="outDecDate"> 
                    <el-date-picker :disabled="editConfig" class="width_100" v-model="outboundForm.outDecDate" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 193px;"> </el-date-picker>
                </el-form-item>   
                <el-form-item label="箱型" prop="boxType">
                    <el-select :disabled="editConfig" placeholder="请选择箱型" v-model="outboundForm.boxType">
                        <el-option v-for="item in boxTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="箱量" prop="planDate">
                    <el-input :disabled="editConfig" suffix-icon="xxxx"> </el-input>
                </el-form-item> -->
                <el-form-item label="入库提单号" prop="rkBlNo">
                    <el-input disabled suffix-icon="xxxx" v-model="outboundForm.rkBlNo"> </el-input>
                </el-form-item>
                <el-form-item label="净重（总）" prop="netWeight">
                    <el-input disabled v-model="outboundForm.netWeight" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="件数1（总）" prop="qty1Sum">
                    <el-input disabled v-model="outboundForm.qty1Sum" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <!-- 贸易方式/运输工具名称/运输工具编号：只有【保税 + 七星河路仓库】必填（:required 控制红星星，其余情况不显示） -->
                <el-form-item label="贸易方式" prop="tradeMode" :required="bondedFieldsRequired">
                    <el-select :disabled="editConfig" class="trade_mode" filterable clearable :default-first-option="true"
                        placeholder="请选择贸易方式" v-model="outboundForm.tradeMode">
                        <el-option v-for="item in tradeModeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                            <span class="margin_right_20">{{ item.codeValue }} -  </span>
                            <span>{{ item.codeName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运输工具名称" prop="trafName" :required="bondedFieldsRequired">
                    <el-input :disabled="editConfig" clearable v-model="outboundForm.trafName" placeholder="请输入运输工具名称" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="运输工具编号" prop="voyNo" :required="bondedFieldsRequired">
                    <el-input :disabled="editConfig" clearable v-model="outboundForm.voyNo" placeholder="请输入运输工具编号" suffix-icon="xxxx"> </el-input>
                </el-form-item>
                <el-form-item label="货物名称" prop="goodsDes" > 
                    <el-input disabled placeholder="" v-model="outboundForm.goodsDes" suffix-icon="xxxx" style="width: 550px;"></el-input>
                </el-form-item>       

        </el-form>
        <el-divider content-position="left">计划信息</el-divider>
        <div class="buttons_box" style="justify-content: space-between;">
            <div>
                <el-button type="primary" size="mini" class="mini_button" @click="IssueRowsSave" :disabled="editConfig">下发暂存</el-button>
                <el-button type="primary" :disabled="editConfig" size="mini" class="mini_button" @click="batchDeleteOutboundPlan">删除</el-button>
                <!-- <el-button type="primary" size="mini" class="mini_button" @click="getIssueAll">查询全部下发任务</el-button> -->
            </div>
            <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
        </div>
        <!-- 计划信息列表 -->
        <vxe-table id="outboundPlanTable"  size="mini" ref="outboundPlanTable" :data="outboundPlanData" :columns="outboundColumns" border stripe
              header-align="center" :custom-config="outboundCustomConfig"   :column-config="{resizable: true,sortable: true,drag:true}"
            :checkbox-config="{labelField: '', highlight: true}" @cell-click="inWarehouseRowsChange" :row-config="{ isCurrent: true,isHover: true}"
            @checkbox-change="outboundPlanRowsCheckbox"  @checkbox-all="outboundPlanRowsCheckbox" max-height="340">
                <!-- 列渲染 -->
                <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in outboundColumns" :field="column.field" :title="column.title" sortable >
                     <template #default="{ row, column }">
                        <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'qty1Unit'"> 
                            {{ row.qty1UnitName }}
                        </span>
                        <span v-else-if="column.field === 'qty2Unit'"> 
                            {{ row.qty2UnitName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <!-- <vxe-column title="操作" width="80" align="center" fixed="right" >
                    <template #default="{ row }">
                        <el-button type="text" :disabled=" (row.rowStatus === '新建' ? false : true) || editConfig" size="mini" class="mini_button" @click="deleteOutboundPlan(row)">删除</el-button>
                    </template>
                </vxe-column> -->
        </vxe-table>
         <!--  -->
        <el-divider content-position="left" >库存信息</el-divider>
        <!-- 查询框 -->
        <el-form class="inventorySeach demo-form-inline" :inline="true" ref="inventorySeachForm" :model="inventorySeachForm" size="mini" label-width="10px">
            <el-form-item label=" " prop="blNo"> 
                <el-input placeholder="请输入提单号" v-model="inventorySeachForm.blNo"  ></el-input>
            </el-form-item>
            <el-form-item label=" " prop="cusDeclNo"> 
                <el-input placeholder="请输入报关单号" v-model="inventorySeachForm.cusDeclNo" ></el-input>
            </el-form-item>
            <el-form-item label=" " prop="boxNo"> 
                <el-input placeholder="请输入箱号" v-model="inventorySeachForm.boxNo"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="spec"> 
                <el-input placeholder="请输入规格型号" v-model="inventorySeachForm.spec"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="note"> 
                <el-input placeholder="请输入备注" v-model="inventorySeachForm.note"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="ownerName"> 
                <el-select filterable placeholder="请选择货主单位" v-model="inventorySeachForm.ownerName" clearable 
                :disabled="outboundForm.ownerName !== ''" >
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" " prop="goodsName"> 
                <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="inventorySeachForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                        <span >{{ item.hsCode }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" " prop="completeDate"> 
                <el-date-picker clearable style="width:193px" v-model="inventorySeachForm.completeDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop=""> 
                <el-button type="primary" size="mini" @click="inventorySeach">搜索</el-button>
                <el-button type="primary" size="mini" @click="batchAddOutboundPlan">批量添加计划</el-button>
            </el-form-item>
        </el-form>
        <!-- 库存信息列表 -->
        <vxe-table id="inventoryTable" size="mini" ref="inventoryTable" :data="inventoryList" border stripe max-height="250"
            :column-config="{resizable: true,sortable: true,drag:true}" header-align="center" :row-config="{ isCurrent: true,isHover: true}"
            :radio-config="{labelField: '', highlight: true}" @checkbox-all="inventoryTableRowsCheckbox" @checkbox-change="inventoryTableRowsCheckbox" 
            :checkbox-config="{labelField: '', highlight: true}"
             :custom-config="{ storage: { resizable: true } }">
            <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="blNo" title="提单号" width="100" fixed="left"></vxe-column>
            <vxe-column field="goodsName" title="货物名称" width="120" ></vxe-column>
            <vxe-column field="ownerName" title="货主单位" width="170"></vxe-column>
            <vxe-column field="hsCode" title="海关编码" width="85"></vxe-column>
            <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
            <vxe-column field="totalQty1" title="件数1" width="100">
                <template #edit="{ row }">
                    <vxe-number-input v-model="row.totalQty1" type="number" placeholder="请输入数值"></vxe-number-input>
                </template>
            </vxe-column>
            <vxe-column field="availableQty1" title="可用数" width="80" ></vxe-column>
            <vxe-column field="occupiedQty1" title="锁定数" width="80"></vxe-column>
            <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
            <vxe-column field="place" title="库区" width="100"></vxe-column>
            <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
            <vxe-column field="totalQty2" title="件数2" width="100"></vxe-column>
            <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
            <vxe-column field="totalNetWeight" title="净重" width="100"></vxe-column>
            <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
            <vxe-column field="totalDecNum" title="申报数量" width="100"></vxe-column>
            <vxe-column field="lawUnitFirstName" title="法一单位" width="100"></vxe-column>
            <vxe-column field="totalFirstNum" title="法一数" width="100"></vxe-column>
            <vxe-column field="lawUnitSecond" title="法二单位" width="100"></vxe-column>
            <vxe-column field="totalSecondNum" title="法二数" width="100"></vxe-column>
            <vxe-column field="customer" title="委托单位" width="170"></vxe-column>
            <vxe-column field="goodsType" title="货物分类" width="70"></vxe-column>
            <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
            <vxe-column field="invDecNo" title="核注清单号" width="100"></vxe-column>
            <vxe-column field="cusDeclNo" title="报关单号" width="100"></vxe-column>
            <vxe-column field="itemNo" title="项号" width="100"></vxe-column>
            <vxe-column field="boxNo" title="箱号" width="100"></vxe-column>
            <vxe-column field="skuNo" title="商品料号" width="100"></vxe-column>
            <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
            <vxe-column field="createDate" title="入库日期" width="100"></vxe-column>
            <vxe-column field="location" title="库位" width="100"></vxe-column>
            <vxe-column field="note" title="备注" width="100"></vxe-column>
            <vxe-column field="lotNo" title="LOT号" width="100"  ></vxe-column>
            <vxe-column field="lotKgs" title="LOT重量" width="80" ></vxe-column>
            <vxe-column field="lotOrderNo" title="LOT订单号" width="100" ></vxe-column>
            <vxe-column field="lotMaterialNo" title="LOT物料号" width="100" ></vxe-column>
            <!-- 操作列 -->
            <vxe-column title="操作" width="100" fixed="right">
                <template v-slot="scope"> 
                    <el-button :disabled="editConfig" type="primary" size="mini" @click="AddOutboundPlan(scope.row)">加入计划</el-button>
                </template>
            </vxe-column>
        </vxe-table>
        <el-divider content-position="left" >作业信息</el-divider>
        <!-- 作业信息列表 -->
        <!-- :expand-config="IssueGoodsRowExpandShow" -->
        <vxe-table id="IssueGoodsTable"  size="mini" ref="IssueGoodsTable" :data="IssueGoodsData" border stripe
            :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="0"  max-height="400">
            <!-- <vxe-column type="checkbox" title="" fixed="left" width="50"></vxe-column>     -->
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column type="expand" width="60" >
                <template #content="{ row }">
                    <div class="expand-wrapper">
                        <vxe-table border :data="row.childList" header-align="center" max-height="350" min-height="50" style="margin: 10px !important;"
                        size="mini" :column-config="{resizable: true,sortable: true}">
                            <vxe-column type="seq" width="50"></vxe-column>
                            <vxe-column field="goodsName" title="货物名称" min-width="120">
                                <template #default="{ row: childRow, $rowIndex }" >
                                    <span>{{ childRow.goodsName }}</span> 
                                    <span v-if="childRow.lotNo">- {{ childRow.lotNo }} - {{ childRow.lotKgs }}</span>
                                    <span v-if="childRow.lotNo" style="display: flex;flex-direction: column;">
                                        <span>订单号:{{ childRow.lotOrderNo }} </span>
                                        <span>物料号:{{ childRow.lotMaterialNo }}</span>
                                    </span>
                                    <span v-else></span>
                                </template>
                            </vxe-column>
                            <vxe-column field="spec" title="规格型号" min-width="120"></vxe-column>
                            <vxe-column field="blNo" title="入库提单号" min-width="120"></vxe-column>
                            <vxe-column field="boxNo" title="入库箱号" min-width="120"></vxe-column>
                            <vxe-column field="place" title="库区库位" min-width="90">
                                <template #default="{ row }">
                                    {{row.place}} - {{row.location}}
                                </template>
                            </vxe-column>
                            <vxe-column field="qty1" title="件数1" min-width="100"></vxe-column>
                            <vxe-column field="qty1Unit" title="件数1单位" width="80">
                                <template #default="{ row }">
                                    {{findNameByCode(row.qty1Unit, unitList)}}
                                </template>
                            </vxe-column>
                            <vxe-column field="qty2" title="件数2" min-width="100"></vxe-column>
                            <vxe-column field="qty2Unit" title="件数2单位" width="80">
                                <template #default="{ row }">
                                    {{findNameByCode(row.qty2Unit, unitList)}}
                                </template>
                            </vxe-column>
                            <vxe-column field="netWeight" title="净重（KG）" min-width="100"></vxe-column>
                            <vxe-column field="decNum" title="申报数量" min-width="100"></vxe-column>
                            <vxe-column field="decAmount" title="申报金额" min-width="100"></vxe-column>
                            <vxe-column field="firstNum" title="法定第一数量" min-width="100"></vxe-column>
                            <vxe-column field="secondNum" title="法定第二数量" min-width="100"></vxe-column>
                        </vxe-table>
                    </div>
                </template>
            </vxe-column>
            <vxe-column field="rowStatus" title="状态" sortable width="70"></vxe-column>
            <vxe-column field="licenseStatus" title="证件状态" sortable width="90">
                <template #default="{ row }">
                    <!-- 验证通过后显示"已验证"，点它可以看这个作业任务上传的证件照片 -->
                    <el-link v-if="isLicenseVerified(row)" type="success" style="font-size: 12px;"
                        @click="showLicensePhoto(row)">{{ row.licenseStatus }}</el-link>
                    <span v-else>{{ row.licenseStatus }}</span>
                </template>
            </vxe-column>
            <vxe-column field="taskNo" title="作业任务单号" min-width="130">
                <template #default="{ row } ">
                    <span v-if="row.rowStatus === '完成'" @click="getCompleteDetails(row)">
                        <el-link  type="primary"  style="font-size: 12px;">{{row.taskNo}}</el-link>
                    </span>
                    <span v-else> {{ row.taskNo }} </span>
                </template>
            </vxe-column>
            <!-- <vxe-column field="blNo" title="提单号" min-width="120"></vxe-column> -->
            <vxe-column field="storekeeper" title="理货员"  min-width="100"></vxe-column>
            <vxe-column field="goodsName" title="货物名称"  min-width="100"></vxe-column>
            <!-- <vxe-column field="spec" title="规格型号"  width="100"></vxe-column> -->
            <vxe-column field="ckName" title="仓库" min-width="90"></vxe-column>
            <vxe-column field="driver" title="司机" min-width="80"></vxe-column>
            <vxe-column field="truckNo" title="车牌" min-width="80"></vxe-column>
            <vxe-column field="qty1" title="总件数1" min-width="80"></vxe-column>
            <vxe-column field="netWeight" title="总净重(KG)" min-width="80"></vxe-column>
            <!-- <vxe-column field="itemNo" title="项号" min-width="80"></vxe-column> -->
            <vxe-column field="boxNo" title="箱号" min-width="120"></vxe-column>
            <vxe-column field="sealNo" title="铅封号" min-width="120"></vxe-column>
            <vxe-column field="note" title="备注" min-width="120"></vxe-column>
            <vxe-column field="opNote" title="现场备注" min-width="120"></vxe-column>
            <vxe-column field="createTime" title="创建时间" sortable  width="130"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
            <vxe-column field="completeDate" title="出库日期" sortable  width="130"  ></vxe-column>
            <!-- <vxe-column title="操作" fixed="right" width="200"> -->
            <vxe-column title="操作" fixed="right" width="220">
                <template #default="{ row }">
                    <el-button type="text" :disabled=" (row.rowStatus !== '完成' ? false : true) || editConfig" size="mini" class="mini_button_text" @click="delIssueRows(row)">删除</el-button>
                    <el-button type="text" :disabled=" (row.rowStatus !== '暂存') || editConfig " size="mini" class="mini_button_text" @click="IssueRows(row)">下发</el-button>
                    <el-button type="text" size="mini" class="mini_button_text" @click="openLicenseVerify(row)" :disabled=" editConfig || isLicenseVerified(row)">证件验证</el-button>
                    <el-button type="text" :disabled=" ((row.rowStatus === '已下发' || row.rowStatus === '作业中' || row.rowStatus === '作业完成' )? false : true) || editConfig"  size="mini" class="mini_button_text" @click="completeRows(row)">完成</el-button>
                    <el-dropdown trigger="click" @command="(command) => report(command, row)">
                        <span class="el-dropdown-link">
                            <el-button type="text" size="mini" class="mini_button_text" >打印</el-button>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="出库受理单">出库受理单</el-dropdown-item>
                            <el-dropdown-item command="出门证">出门证</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </vxe-column>
        </vxe-table>
        <div style="width: 100%;height: 200px;"></div>
        <!-- 出库计划信息弹出框 -->
        <el-dialog title="出库计划信息" width="75%" :visible.sync="inventoryPlanVisible" :before-close="inventoryPlanClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-descriptions title="" :column="4" size="medium">
                <el-descriptions-item label="保税类型">{{ inventorySelected.isBonded }}</el-descriptions-item>
                <el-descriptions-item label="货物名称">{{ inventorySelected.goodsName }}</el-descriptions-item>
                <el-descriptions-item :span="2" label="规格型号">{{ inventorySelected.spec }}</el-descriptions-item>
                <el-descriptions-item label="货主单位">{{ inventorySelected.ownerName }}</el-descriptions-item>
                <el-descriptions-item label="提单号">{{ inventorySelected.blNo }}</el-descriptions-item>
                <el-descriptions-item label="报关单号">{{ inventorySelected.cusDeclNo }}</el-descriptions-item>
                <el-descriptions-item label="核注清单号">{{ inventorySelected.invDecNo }}</el-descriptions-item>
                <el-descriptions-item label="项号">{{ inventorySelected.itemNo }}</el-descriptions-item>
                <el-descriptions-item label="箱号">{{ inventorySelected.boxNo }}</el-descriptions-item>
                <el-descriptions-item label="仓库" :span="2">{{ inventorySelected.ckName }} - {{ inventorySelected.place }} - {{ inventorySelected.location }}</el-descriptions-item>
                <el-descriptions-item label="净重(KG)">{{ inventorySelected.totalNetWeight }}</el-descriptions-item>
                <el-descriptions-item label="申报数量">{{ inventorySelected.totalDecNum }} {{ inventorySelected.decUnitName }}</el-descriptions-item>
                <el-descriptions-item label="申报金额">{{ inventorySelected.totalDecAmount }} {{ inventorySelected.decCurrency }}</el-descriptions-item>
                <el-descriptions-item label="件数1">{{ inventorySelected.totalQty1 }} {{ inventorySelected.qty1UnitName }}</el-descriptions-item>
                <el-descriptions-item label="件数2">{{ inventorySelected.totalQty2 }} {{ inventorySelected.qty2UnitName }}</el-descriptions-item>
                <el-descriptions-item label="法定第一数量">{{ inventorySelected.totalFirstNum }} {{ inventorySelected.lawUnitFirstName }}</el-descriptions-item>
                <el-descriptions-item label="法定第二数量">{{ inventorySelected.totalSecondNum }} {{ inventorySelected.lawUnitSecondName }}</el-descriptions-item>
            </el-descriptions>
            <!-- 打开默认填写所有值，修改件数时同时修改净重和申报数量和申报金额 -->
            <el-form class="demo-form-inline" :inline="true" ref="inventoryPlanForm" :model="inventoryPlanForm" size="mini" label-width="120px"
            :rules="inventoryPlanRules">
                <el-form-item label="件数1" prop="qty1"> 
                    <el-input  v-model="inventoryPlanForm.qty1" @blur="qty1Blur"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="件数2" :prop="inventorySelected.totalQty2? 'qty2':''" > 
                    <el-input :disabled="!inventorySelected.totalQty2" v-model="inventoryPlanForm.qty2"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="净重(KG)" prop="netWeight"> 
                    <el-input v-model="inventoryPlanForm.netWeight"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报数量" :prop="inventorySelected.totalDecNum? 'decNum':''" > 
                    <el-input :disabled="!inventorySelected.totalDecNum" v-model="inventoryPlanForm.decNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第一数量" :prop="inventorySelected.totalFirstNum? 'firstNum':''"> 
                    <el-input :disabled="!inventorySelected.totalFirstNum" v-model="inventoryPlanForm.firstNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第二数量" :prop="inventorySelected.totalSecondNum? 'secondNum':''" > 
                    <el-input :disabled="!inventorySelected.totalSecondNum" v-model="inventoryPlanForm.secondNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报金额" :prop="inventorySelected.totalDecAmount? 'ckAmount':''"> 
                    <el-input :disabled="!inventorySelected.totalDecAmount" v-model="inventoryPlanForm.ckAmount"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="单价" :prop="inventorySelected.ckPrice? 'ckPrice':''"> 
                    <el-input :disabled="!inventorySelected.decPrice" v-model="inventoryPlanForm.ckPrice" @blur="ckPriceBlur" suffix-icon="xxxx"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddInventoryPlan">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 下发暂存弹出框 -->
         <el-dialog title="任务下发" width="95%" :visible.sync="IssueGoodsVisible" :before-close="IssueGoodsClose" v-dialogDrag
             :close-on-click-modal="false">
                <!-- 识别小票：上传图片或高拍仪拍照，识别后回填下面的车牌、箱号、铅封号、司机 -->
                <parseTicket ref="parseTicket" @success="fillIssueGoodsByCarBox"></parseTicket>
                <!-- 下发填写表单 -->
                <el-form :model="issueGoodsForm" ref="issueGoodsForm" class="demo-form-inline " size="mini" label-width="80px"
                :rules="issueGoodsFormRules">
                    <el-row>
                        <el-col :span="5">
                             <el-form-item label="理货员" prop="storekeeper">
                                <el-select class="width_100"  v-model="issueGoodsForm.storekeeper" placeholder="请选择理货员" >
                                    <el-option v-for="item in storekeeperList"  :key="item.userName" :label="item.userName " :value="item.userName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="车牌" prop="truckNo">
                                <!-- <el-input v-model="issueGoodsForm.truckNo" placeholder="请输入车牌"></el-input> -->
                                <el-select class="width_100" v-model="issueGoodsForm.truckNo" placeholder="请选择或输入车牌" filterable remote @focus="driverTruckNoList=[]"
                                :remote-method="truckNoRemoteMethod" @change="truckNoHandleChange($event,'issueGoodsForm')" @blur="selectTruckNo($event,'issueGoodsForm')" :default-first-option="true" >
                                    <el-option v-for="item in driverTruckNoList" :key="item.id" :label="item.carNo" :value="item.carNo + '-' + item.driver " >
                                        <span>{{ item.carNo }} - {{ item.driver }} </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                             <el-form-item label="司机" prop="driver">
                                <el-input v-model="issueGoodsForm.driver" placeholder="请输入司机"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="箱号" prop="boxNo">
                                <el-input v-model="issueGoodsForm.boxNo" placeholder="请输入箱号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="铅封号" prop="sealNo">
                                <el-input v-model="issueGoodsForm.sealNo" placeholder="请输入铅封号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="备注" prop="note">
                                <el-input v-model="issueGoodsForm.note" placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-divider content-position="left">下发信息</el-divider>
                <vxe-table border size="mini" ref="exitIssueGoodsTable" :data="outboundPlanCheckboxExitRow" :row-config="{keyField: 'id'}" header-align="center"
                max-height="350px">
                    <vxe-column field="goodsName" title="货物信息"  fixed="left" width="150">
                        <template #default="{ row, $rowIndex }" >
                            <span >{{ row.goodsName }} - {{ row.spec }}</span>
                        </template>
                    </vxe-column>
                     <vxe-column field="place" title="库区库位"  fixed="left" width="100">
                        <template #default="{ row, $rowIndex }" >
                            {{ row.place }} - {{ row.location }}
                        </template>
                    </vxe-column>
                    <vxe-column field="qty1" title="件数1"  >
                        <template #default="{ row, $rowIndex }" >
                            <span class="IssueGoodsExitRow">
                                <!-- style="flex-grow:1" -->
                                <el-input  v-model="row.qty1" placeholder="请输入件数1" size="mini" 
                                    onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" @blur="IssueGoodsRowQty1Blur(row,$rowIndex)"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].qty1 }} / {{  outboundPlanCheckbox[$rowIndex].workedQty1 }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="qty2" title="件数2" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow">
                                <el-input v-model="row.qty2" :disabled="!outboundPlanCheckbox[$rowIndex].qty2" placeholder="请输入件数2" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].qty2 }} / {{  outboundPlanCheckbox[$rowIndex].workedQty2 }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="netWeight" title="净重（KG）" >
                        <template #default="{ row, $rowIndex }" >
                            <span class="IssueGoodsExitRow" >
                                <el-input  v-model="row.netWeight" :disabled="!outboundPlanCheckbox[$rowIndex].netWeight" placeholder="请输入净重" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].netWeight }} / {{  outboundPlanCheckbox[$rowIndex].workedNetWeight }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="decNum" title="申报数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.decNum" :disabled="!outboundPlanCheckbox[$rowIndex].decNum" placeholder="请输入申报数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" ></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].decNum }} / {{  outboundPlanCheckbox[$rowIndex].workedDecNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="decAmount" title="申报金额" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.decAmount" :disabled="!outboundPlanCheckbox[$rowIndex].decAmount" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" size="mini" placeholder="请输入申报金额"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].decAmount }} / {{  outboundPlanCheckbox[$rowIndex].workedAmount }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="firstNum" title="法定第一数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.firstNum" :disabled="!outboundPlanCheckbox[$rowIndex].firstNum" placeholder="请输入法一数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].firstNum }} / {{  outboundPlanCheckbox[$rowIndex].workedFirstNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="secondNum" title="法定第二数量" >
                        <template #default="{ row, $rowIndex }">
                            <span class="IssueGoodsExitRow" >
                                <el-input v-model="row.secondNum" :disabled="!outboundPlanCheckbox[$rowIndex].secondNum " placeholder="请输入法二数量" size="mini" onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                                <span class="IssueGoodsTipText">待/已下发：{{ outboundPlanCheckbox[$rowIndex].secondNum }} / {{  outboundPlanCheckbox[$rowIndex].workedSecondNum }}</span>
                            </span>
                        </template>
                    </vxe-column>
                    <!-- 硫磺列 -->
                     <vxe-column field="lotNo" title="LOT信息"  width="180" v-if="issueGoodsLOTColumn">
                        <template #default="{ row, $rowIndex }" >
                            <span v-if="row.lotNo" style="display: flex;flex-direction: column;">
                                <span>LOT号:{{ row.lotNo }} - 重量:{{ row.lotKgs }}</span>
                                <span>订单号:{{ row.lotOrderNo }} </span>
                                <span>物料号:{{ row.lotMaterialNo }}</span>
                            </span>
                            <span v-else></span>
                        </template>
                    </vxe-column>
                </vxe-table>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="IssueGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveIssueGoods">保 存</el-button>
                </span>
        </el-dialog>
        <!-- 任务单附件弹窗 -->
        <el-dialog title="任务单附件" width="80%" :visible.sync="taskMainFilesVisible" :before-close="taskMainFilesClose" v-dialogDrag
         :close-on-click-modal="false" >
            <el-table :data="taskMainFilesList" v-loading="taskMainFilesLoading" size="mini" border stripe
             max-height="400" header-align="center">
                <el-table-column prop="fileType" label="附件类型" align="center" width="200"></el-table-column>
                <el-table-column prop="fileName" label="附件名称" align="center"></el-table-column>
                <el-table-column prop="uploadUser" label="上传人" align="center" width="200"></el-table-column>
                <el-table-column prop="uploadTime" label="上传时间" align="center" width="250"></el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="viewTaskMainFile(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="taskMainFilesClose">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 核放单识别弹窗：选本地图片/拖拽图片，识别后回填核放单号 -->
        <el-dialog title="核放单识别" width="40%" :visible.sync="checkReleaseVisible" :before-close="checkReleaseClose" v-dialogDrag
         :close-on-click-modal="false" >
            <el-upload drag ref="checkReleaseUpload" action="#" :auto-upload="false" :limit="1"
             accept="image/png,image/jpeg,image/jpg,image/bmp,.pdf" :file-list="checkReleaseFileList"
             :on-change="checkReleaseFileChange" :on-remove="checkReleaseFileRemove" :on-exceed="checkReleaseFileExceed">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将核放单图片拖到此处，或<em>点击选择本地图片</em></div>
                <div class="el-upload__tip" slot="tip">支持图片或PDF，只能选一个文件，重复选择会覆盖</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="checkReleaseClose">取 消</el-button>
                <el-button size="mini" type="primary" :loading="checkReleaseLoading" @click="checkReleaseParse">识 别</el-button>
            </span>
        </el-dialog>
        <!-- 查看完成后的任务信息 -->
        <viewCompletework :viewCompleteworkVisible="viewCompleteworkVisible" :completeworkRow="completeworkRow"
        @viewCompleteworkClose="viewCompleteworkClose"></viewCompletework>
        <!-- 高拍仪拍照弹窗（证件验证用，只拍照不上传） -->
        <photoScan ref="LicenseDialog" :onlyPhoto="true" @uploadSuccess="handleLicensePhoto"></photoScan>
        <!-- 证件照片：本体不显示，只借 el-image 的查看大图（点背景或右上角关闭，支持滚轮缩放、ESC） -->
        <el-image ref="licensePreview" class="license_preview_hidden" :src="licensePhotoList[0] || ''"
            :preview-src-list="licensePhotoList"></el-image>
        <!-- AI识别弹窗 -->
        <AIRecognition ref="AIRecognition" :form="outboundForm" :subList="outboundPlanData"
            @taskSaved="aiParseSaved"></AIRecognition>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import AEObasicData from '@/config/AEObasicData.js'
import { findNameByCode, findCodeByName } from '@/utils/dict.js'
import basicData from '@/config/basicData.js'
import viewCompletework from '@/components/wms/viewCompletework.vue'
import photoScan from '@/components/wms/photoScan.vue'
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
import { set } from 'nprogress';
import clean from 'lodash-clean';
import { VxeRow } from 'vxe-pc-ui';
import AIRecognition from '@/components/wms/AIRecognition.vue'
import parseTicket from '@/components/wms/parseTicket.vue'
export default {
    name: 'outbound',
    mixins: [userProfile],
    components:{
        viewCompletework,
        photoScan,
        AIRecognition,
        parseTicket
    },
    watch: { 
        // 根据仓库不同切换不同的理货员
        'outboundForm.ckName':{
            handler(newVal, oldVal) {
                this.wmsMobileGetUserList(newVal)
                // 仓库变化后重新判断核放单号是否可填
                this.clearCheckNoWhenNotAllowed()
            },
            immediate: true, // 是否立即执行一次
            deep: false // 是否深度监听
        },
        // 保税类型变化后重新判断核放单号是否可填
        'outboundForm.isBonded':{
            handler(newVal, oldVal) {
                this.clearCheckNoWhenNotAllowed()
            },
            deep: false
        },
        // 【保税 + 七星河路仓库】条件不满足后，清掉贸易方式/运输工具名称/运输工具编号的必填红字提示
        // （computed 里同时依赖保税类型和仓库，改哪个都会触发）
        bondedFieldsRequired:{
            handler(newVal, oldVal) {
                if (!newVal && this.$refs.outboundForm) {
                    this.$nextTick(() => {
                        this.$refs.outboundForm && this.$refs.outboundForm.clearValidate(['tradeMode', 'trafName', 'voyNo'])
                    })
                }
            },
            deep: false // 是否深度监听
        },
    },
    computed:{
        // 贸易方式/运输工具名称/运输工具编号：只有【保税 + 七星河路仓库】才必填，其余情况不必填
        bondedFieldsRequired(){
            return this.outboundForm.isBonded === '保税' && this.outboundForm.ckName === '七星河路仓库'
        }
    },
    data() {
        // 自定义验证函数  件数1出库计划
        const validateQty1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalQty1) {
                return callback(new Error(`件数1不能超过 ${this.inventorySelected.totalQty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数2出库计划
        const validateQty2 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalQty2) {
                return callback(new Error(`件数2不能超过 ${this.inventorySelected.totalQty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  净重出库计划
        const validateNetWeight = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalNetWeight) {
                return callback(new Error(`净重不能超过 ${this.inventorySelected.totalNetWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报数量出库计划
        const validateDecNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalDecNum) {
                return callback(new Error(`申报数量不能超过 ${this.inventorySelected.totalDecNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法1出库计划
        const validateFirstNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalFirstNum) {
                return callback(new Error(`法定第一数量不能超过 ${this.inventorySelected.totalFirstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法2出库计划
        const validateSecondNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventorySelected.totalSecondNum) {
                return callback(new Error(`法定第二数量不能超过 ${this.inventorySelected.totalSecondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报金额出库计划
        const validateDecAmount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            // if (parseFloat(value) > this.inventorySelected.totalDecAmount) {
            //     return callback(new Error(`申报金额不能超过 ${this.inventorySelected.totalDecAmount}`)); // 不能超过最大值
            // }
            callback(); // 验证通过
        };
        // 保税任务必填校验：保税类型为“保税”且仓库为七星河路仓库时，贸易方式/运输工具名称/运输工具编号不能为空
        const bondedRequired = (label, verb) => (rule, value, callback) => {
            const isEmpty = !String(value == null ? '' : value).trim();
            if (this.bondedFieldsRequired && isEmpty) {
                return callback(new Error(`保税任务请${verb || '填写'}${label}`));
            }
            callback();
        };
        return{
            editConfig:false, // 控制任务是否可编辑
            outboundCustomConfig:null, // 自定义表格配置
            outboundForm:{ // 表头
                id:'', 
                taskType: '出库', // 出入库类型
                billNo:'', // 入库单号
                taskStatus:'新建', // 状态
                createUser:'', // 单证人
                createDate:'', // 创建日期
                planDate:'', // 计划作业日期
                outDecDate:'', // 出库申报日期
                blNo:'', // 出库提单号
                isBonded:'' , // 保税属性
                handbook:'' , // 账册编号
                cusDeclNo:'', // 出库报关单号
                invDecNo:'', // 出库核注清单号
                checkNo:'', // 核放单号
                customer:'', // 提货方
                ownerName:'', // 货主单位
                ckName:'', // 仓库
                boxType:'', // 箱型
                boxNum:'', // 箱量
                // grossWeight:'', // 毛重(总)
                netWeight:'', // 净重(总)
                qty1Sum:'', // 件数1(总)
                qty2Sum:'', // 件数2(总)
                // volume:'', // 体积(总)
                goodsDes:'', // 货物名称
                tradeMode:'', // 贸易方式（监管方式代码）
                trafName:'', // 运输工具名称
                voyNo:'', // 运输工具编号
            },// 出库表头
            inventorySeachForm:{
                blNo:'', // 提单号
                cusDeclNo:'', // 报关单号
                ownerName:'', // 货主
                isBonded:'', // 保税类型
                ckName:'', // 仓库
                boxNo:'',// 箱号
                completeDate:'',// 入库日期
                goodsName:'', // 货物名称
                spec:'',
                npte:'',
            },
            hasHandledToken: false, // 是否处理过token
            customerList:[], // 客户列表
            boxTypeList:[], // 箱型列表
            goodsList:[], // 货物名称列表
            inventoryList:[], // 库存列表
            currencyList:AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制列表
            tradeModeList:AEObasicData.CUS_MAPPING_TRADE_CODE_V, // 贸易方式（监管方式）列表，存代码、显示“代码 - 名称”
            inventorySelected:{}, // 选中库存信息
            inventoryPlanVisible:false, // 库存信息弹出框
            inventoryPlanForm:{}, // 出库计划输入信息
            outboundPlanData:[], // 出库计划表格
            inventoryPlanRow:{}, // 选中计划信息表格行
            outboundPlanCheckbox:[], // 计划信息多选表格
            inventoryTableCheckbox:[], // 库存多选表格
            outboundPlanCheckboxExitRow:[], // 用来进行修改
            driverTruckNoList:[], // 司机车牌列表
            issueGoodsForm:{
                taskType:'出库作业', // 任务类型
                storekeeper:'', // 理货员
                driver:'', // 司机
                truckNo :'', // 车牌
                sealNo:'', // 铅封号
                boxNo:'', // 箱号
                interId:'', // 主id
                createUser:'', // 单证员
                remark:'', // 备注
                handbook:'', // 账册编号
                ckName:'', // 仓库
                blNo:'', // 提单号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                isBonded:'', // 保税类型
                boxType:'', // 箱型
                boxNum:'', // 箱量
                ownerName:'', // 货主
                childList:[],
                note:'',
            }, // 下发作业填写表单
            issueGoodsLOTColumn:false, // 下发暂存的时候是否显示LOT
            IssueGoodsVisible:false, // 下发弹出框显示
            IssueGoodsData:[], // 下发任务表格
            storekeeperList:[], // 理货员列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            //实际使用的列配置（从本地存储恢复或用默认）
            outboundColumns:[],
            // 出库计划验证规则
            inventoryPlanRules:{
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2, trigger: "blur" }
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeight, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNum, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNum, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNum, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmount, trigger: "blur" }
                ],
            },
            // 表头验证规则：贸易方式/运输工具名称/运输工具编号（保税 + 七星河路仓库时必填）
            outboundFormRules:{
                tradeMode:[
                    { validator: bondedRequired('贸易方式', '选择'), trigger: 'change' }
                ],
                trafName:[
                    { validator: bondedRequired('运输工具名称'), trigger: 'blur' }
                ],
                voyNo:[
                    { validator: bondedRequired('运输工具编号'), trigger: 'blur' }
                ],
            },
            // 下发暂存验证规则
            issueGoodsFormRules:{
                storekeeper:[
                    { required: true, message: '请选择理货员', trigger: 'change' }
                ],
                driver:[
                    { required: true, message: '请输入司机', trigger: 'blur' },
                ],
                truckNo:[
                    { required: true, message: '请输入车牌', trigger: 'blur' },
                ],
                // netWeight:[
                //     { required: true, message: '请输入净重', trigger: 'blur' },
                //     { validator: validateNetWeightIssueGoods, trigger: "blur" }
                // ],
                // qty1:[
                //     { required: true, message: '请输入件数1', trigger: 'blur' },
                //     { validator: validateQty1IssueGoods, trigger: "blur" }
                // ],
                // qty2:[
                //     { required: true, message: '请输入件数2', trigger: 'blur' },
                //     { validator: validateQty2IssueGoods, trigger: "blur" }
                // ],
                // decNum:[
                //     { required: true, message: '请输入申报数量', trigger: 'blur' },
                //     { validator: validateDecNumIssueGoods, trigger: "blur" }
                // ],
                // decAmount:[
                //     { required: true, message: '请输入申报金额', trigger: 'blur' },
                //     { validator: validateDecAmountIssueGoods, trigger: "blur" }
                // ],
                // firstNum:[
                //     { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                //     { validator: validateFirstNumIssueGoods, trigger: "blur" }
                // ],
                // secondNum:[
                //     { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                //     { validator: validateSecondNumIssueGoods, trigger: "blur" }
                // ],
            },
            // 查看完成作业弹窗
            viewCompleteworkVisible:false,
            completeworkRow:{}, // 完成的row信息
            licenseTaskRow:{}, // 证件验证：打开高拍仪时记下的作业任务行，拍照回来要用
            licensePhotoList:[], // 证件验证：查到的证件照片地址，用 el-image 直接打大图
            taskMainFilesVisible:false, // 任务单附件弹窗
            taskMainFilesList:[], // 任务单附件列表
            taskMainFilesLoading:false, // 任务单附件加载中
            checkReleaseVisible:false, // 核放单识别弹窗
            checkReleaseFileList:[], // 核放单识别已选文件（展示用）
            checkReleaseFileRaw:null, // 核放单识别原始文件
            checkReleaseLoading:false, // 核放单识别中
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.outboundCustomConfig = this.customConfig // 表格定义列
                    this.getCompanyList()
                    this.getBoxTypeList()
                    this.getWMSTaskDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
        this.outboundForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
        window.addEventListener('beforeunload', this.notifyParentBeforeUnload);
        this.setupMessageListener();

    },
    methods: {
        // 接收父窗口的消息
        handleMessage(event) {
            if (event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                this.hasHandledToken = true;
                // 只清任务id，不能用 clear()：正式环境父子窗口同源，clear 会把列表页的 openedWindowsBoolean（限制只开一个窗口的锁）一起清掉
                localStorage.removeItem('id')
                localStorage.setItem('token', event.data.token);
                localStorage.setItem('name', event.data.name);
                localStorage.setItem('parentOrigin', event.data.parentOrigin);
                // 向父窗口发送消息
                event.source.postMessage(
                    { type: 'TOKEN_RECEIVED' },
                    event.origin
                );
                Promise.resolve().then(() => {
                    this.outboundCustomConfig = this.customConfig // 表格定义列
                    this.getCompanyList()
                    this.getBoxTypeList()
                    if(event.data.id !== ''){
                        localStorage.setItem('id', event.data.id);
                        this.getWMSTaskDetail(localStorage.getItem('id'))
                    }else{
                        this.outboundForm.createUser = event.data.name
                    }
                })
            }
        },
        // 查询任务详情
        async getWMSTaskDetail(id){
            this.$api.getWMSTaskDetail(id).then(res =>{
                this.outboundForm = res.taskMain
                // 贸易方式/运输工具名称/运输工具编号是后加的字段，老数据可能没有：补齐并保证响应式
                // （用变量接住数组，避免上一行没分号时被解析成 res.taskMain[...] 取属性）
                const addFields = ['tradeMode', 'trafName', 'voyNo']
                addFields.forEach(key => {
                    if (this.outboundForm[key] === undefined || this.outboundForm[key] === null) {
                        this.$set(this.outboundForm, key, '')
                    }
                })
                this.inventorySeachForm.ownerName = res.taskMain.ownerName
                //查询inWarehouseData中编码对应的汉字
                this.outboundPlanData = this.processTableData(res.taskSub.tableData);
                this.outboundColumns = res.taskSub.columns
                // 判断是否结束
                this.editConfig = this.outboundForm.billStatus === '结束' ? true : false
            })
        },
        // 通用查找方法
        findNameByCode(code, list) {
           return findNameByCode(code, list)
        },
        // 处理整个数组的数据转换
        processTableData(data) {
            return data.map(item => ({
            ...item,
            decCurrencyName: this.findNameByCode(item.decCurrency, this.currencyList), // 币制
            lawUnitFirstName: this.findNameByCode(item.lawUnitFirst, this.unitList), // 法一单位
            lawUnitSecondName: this.findNameByCode(item.lawUnitSecond, this.unitList), // 法二单位
            decUnitName: this.findNameByCode(item.decUnit, this.unitList), // 申报单位
            qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList), // 件数1单位
            qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList), // 件数2单位
            }));
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取理货员列表
        async wmsMobileGetUserList(ckName){
            try{
                const res = await this.$api.wmsMobileGetUserList(1,100, { ckName:ckName,isTally:1})
                const data = res || {}
                // 兼容分页返回
                const list = Array.isArray(data) ? data : data.records || data.tableData || []
                // 拿到数据再赋值！
                this.storekeeperList = list
                
            }catch(e){
                console.error('获取失败',e)
                this.storekeeperList = []
            }
        },
        // 获取箱型列表
        getBoxTypeList(){
            this.$api.getDicList( { value:'箱型'} ).then(res =>{
                this.boxTypeList = res
            })
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.getInUseListBy({param:value} ).then(res =>{
            // this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 搜索库存信息
        inventorySeach(){
            // 提单号必填
            if(this.inventorySeachForm.blNo === '' &&  this.inventorySeachForm.cusDeclNo === '' &&  this.inventorySeachForm.boxNo === '' && this.inventorySeachForm.ownerName === ''
                && this.inventorySeachForm.goodsName === '' && this.inventorySeachForm.completeDate === '' && this.inventorySeachForm.note === '' && this.inventorySeachForm.spec === ''){
                this.$message.error('请填写提单号/报关单号/箱号/货主单位/货物名称/入库时间')
                return
            }
            // this.inventorySeachForm.ownerName = this.outboundForm.ownerName
            this.inventorySeachForm.isBonded = this.outboundForm.isBonded
            this.inventorySeachForm.ckName = this.outboundForm.ckName
            const params = clean(this.inventorySeachForm);
            this.$api.wmsGetStockList( params ,1000,1).then(res =>{
                this.inventoryList = res.records
            })
        },
        // 搜索司机-车牌
        truckNoRemoteMethod(value){
            this.$api.wmsGetCarInfo( value ).then(res =>{
                this.driverTruckNoList = res
            })
        },
        // 值变化处理
        truckNoHandleChange(value,code) {
            const item  = value.split('-')
            if(code === 'issueGoodsForm'){
                this.issueGoodsForm.truckNo = item[0]
                this.issueGoodsForm.driver = item[1]
            }
        
        },
        // 输入
        selectTruckNo(e,code){
            // blur 时先把输入框的值取出来（blur 之后输入框的值可能被清掉）
            const value = e.target.value
            if (value !== '') {
                // 延迟到下一个 tick 再赋值：blur 里同步改 v-model 会触发下拉框重渲染，把点「保存」的第一次点击吞掉
                this.$nextTick(() => {
                    if(code === 'issueGoodsForm'){
                        this.issueGoodsForm.truckNo = value
                    }
                })
            }
        },
        // 保存表头
        async saveOutboundForm(){
            // 先做表单校验：保税任务的贸易方式/运输工具名称/运输工具编号必填，规则见 outboundFormRules
            const valid = await new Promise((resolve) => {
                this.$refs.outboundForm.validate((flag) => resolve(flag))
            })
            if (!valid) {
                this.$message.warning('请先完善表头必填项：保税任务的贸易方式、运输工具名称、运输工具编号不能为空')
                return
            }
            try {
                // 判断是否有单号，没有单号先获取单号
                if(!this.outboundForm.billNo){
                    await this.getWMSBillNo()
                }
                // 保存表头
                await this.outboundSaveMain()
            } catch (error) {
                // request.js 已经弹过错误提示，这里避免重复弹出
                if (!error || !error._toastShown) {
                    this.$message.error('表头保存失败，请稍后重试')
                }
            }
        },
        // 获取出库单号
        async getWMSBillNo() {
            try {
                const res = await this.$api.getWMSBillNo('CK');
                this.outboundForm.billNo = res;
                return res; // 这里返回获取到的单号
            } catch (error) {
                throw error; // 抛出错误让外层捕获
            }
        },
        // 保存表头
        async outboundSaveMain(){
            const res = await this.$api.saveMain(this.outboundForm);
            if (localStorage.getItem('id')) {
                localStorage.setItem('id', res);
            }
            // 等待查询详情完成
            await this.getWMSTaskDetail(res);
            this.$message.success('保存成功');
        },
        // 将库存添加到出库计划
        AddOutboundPlan(data){
            // 弹出框写出库信息
            this.inventorySelected = data
            if( this.inventorySelected.availableQty1 === this.inventorySelected.totalQty1 ){
                this.inventoryPlanForm = {
                    qty1: this.inventorySelected.availableQty1,
                    qty2:   this.inventorySelected.totalQty2,
                    netWeight:  this.inventorySelected.totalNetWeight,
                    decNum: this.inventorySelected.totalDecNum,
                    decAmount:  this.inventorySelected.totalDecAmount,
                    firstNum: this.inventorySelected.totalFirstNum,
                    secondNum: this.inventorySelected.totalSecondNum,
                    ckPrice: this.inventorySelected.decPrice,
                    decPrice: this.inventorySelected.decPrice,
                    ckAmount: this.inventorySelected.totalDecAmount,
                }

            }else{
                this.inventoryPlanForm = {
                    qty1: this.inventorySelected.availableQty1,
                    qty2:   this.calculateAllPlanFields(this.inventorySelected.totalQty2,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    netWeight:  this.calculateAllPlanFields(this.inventorySelected.totalNetWeight,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    decNum: this.calculateAllPlanFields(this.inventorySelected.totalDecNum,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    decAmount:  this.calculateAllPlanFields(this.inventorySelected.totalDecAmount,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    firstNum: this.calculateAllPlanFields(this.inventorySelected.totalFirstNum,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    secondNum: this.calculateAllPlanFields(this.inventorySelected.totalSecondNum,this.inventorySelected.totalQty1,this.inventorySelected.availableQty1),
                    ckPrice: this.inventorySelected.decPrice,
                    decPrice: this.inventorySelected.decPrice,
                    ckAmount: this.inventorySelected.totalDecAmount,

                }
            }
            // 查询lot号
            // this.seacherLotNo(data)
            this.inventoryPlanVisible = true
        },
        // 当出库计划中的件数1发生改变时，同时改件数2，净重，申报数量，金额
        qty1Blur(){
            // 净重
            this.inventoryPlanForm.netWeight = this.calculateAllPlanFields(this.inventorySelected.totalNetWeight,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.qty2 = this.calculateAllPlanFields(this.inventorySelected.totalQty2,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.decNum = this.calculateAllPlanFields(this.inventorySelected.totalDecNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.decAmount = this.calculateAllPlanFields(this.inventorySelected.totalDecAmount,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.firstNum = this.calculateAllPlanFields(this.inventorySelected.totalFirstNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
            this.inventoryPlanForm.secondNum = this.calculateAllPlanFields(this.inventorySelected.totalSecondNum,this.inventorySelected.totalQty1,this.inventoryPlanForm.qty1)
        },  
        // 修改出库单价，同时改变出库总价
        ckPriceBlur(){
            if(!this.inventoryPlanForm.ckPrice){
                return null
            }else{
                const value = Number(this.inventoryPlanForm.ckPrice) || 0;
                this.inventoryPlanForm.ckAmount =  value * this.inventoryPlanForm.netWeight;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1All,qty1Actual){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1All); // 选中数据的件数1
                const planQty1 = Number(qty1Actual); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 关闭出库计划弹出框
        inventoryPlanClose(){
            this.inventoryPlanVisible = false
            this.inventorySelected = {}
            this.inventoryPlanForm = {}
            this.$refs.inventoryPlanForm.resetFields();
        },
        // 控制复选框是否可选
        checkSelecLOTNo(row, index) {
            // kgs 为 0 时返回 false，表示不可选
            // 注意：可能需要转换为数字类型进行比较
            const kgs = Number(row.kgs);
            return kgs !== 0;
        },
        // 多选库存信息
        inventoryTableRowsCheckbox(){
            const selectedRecords = this.$refs.inventoryTable.getCheckboxRecords();
            this.inventoryTableCheckbox = selectedRecords
        },
        // 批量添加出库计划
        async batchAddOutboundPlan(){
            
            try{
                if(!this.inventoryTableCheckbox.length){
                    this.$message.error('请选择要添加的库存信息');
                    return false
                }
                this.$confirm('是否确认添加出库计划?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 判断所选信息是否可以一起出库,货主,仓库,账册编号,报税类型,只有一条不验证
                    if(this.inventoryTableCheckbox.length > 1){
                        const first = this.inventoryTableCheckbox[0]
                        // 需要检查的字段
                        const checkFields = ['ownerName', 'ckName', 'handbook', 'isBonded']
                        // 遍历所有剩下的项，逐个比对
                        for (const item of this.inventoryTableCheckbox.slice(1)) {
                            // 逐个检查每个字段
                            for (const field of checkFields) {
                                // 比对值（处理了undefined/null的情况，保证全等）
                                if (item[field] !== first[field]) {
                                    // 任意一个不一样，直接弹提示，返回false拦截
                                    this.$message.warning(`选中数据${field}不一致，全部数据需要一致才能继续操作`)
                                    return false
                                }
                            }
                        }
                    }
                    // 数据一致后,判断是否保存表头，没保存则先保存表头，保存表头后保存表体
                    if( this.outboundForm.billNo === ''){
                        this.outboundForm.billNo = await this.getWMSBillNo()
                    }
                    
                    // 判断表头的账册、仓库、保税类型、货主是否有值
                    if (this.outboundForm.handbook === '' && this.outboundForm.ckName === '' && this.outboundForm.isBonded === '' && 
                        this.outboundForm.ownerName === '') {
                        this.outboundForm.handbook = this.inventoryTableCheckbox[0].handbook
                        this.outboundForm.ckName = this.inventoryTableCheckbox[0].ckName
                        this.outboundForm.isBonded = this.inventoryTableCheckbox[0].isBonded
                        this.outboundForm.ownerName = this.inventoryTableCheckbox[0].ownerName
                        // 等待保存表头完成
                        const res = await this.$api.saveMain(this.outboundForm);
                        this.outboundForm.id = res
                        if (localStorage.getItem('id')) {
                            localStorage.setItem('id', res);
                        }
                    }
                    const newParamsList = this.inventoryTableCheckbox.map(item => {
                        const params = {
                            taskType:'出库',
                            rowStatus: '', // 状态   
                            blNo: item.blNo, // 提单号
                            interId: this.outboundForm.id, // 父id
                            goodsType: item.goodsType, // 货物类型
                            hsCode: item.hsCode, // 海关编码
                            goodsName: item.goodsName, // 货物名称
                            spec: item.spec, // 规格型号
                            ownerName: item.ownerName, // 货主
                            ckName: item.ckName, // 仓库
                            place: item.place, // 库区
                            location: item.location, // 库位
                            qty1Unit: item.qty1Unit, // 件数1单位
                            qty2Unit: item.qty2Unit, // 件数2单位
                            decUnit: item.decUnit, // 申报单位代码
                            decCurrency: item.decCurrency, // 币制
                            stockDate:item.createDate ,// 入库日期
                            originCountry:item.originCountry, // 原产地 
                            lawUnitFirst: item.lawUnitFirst, // 法一单位
                            lawUnitSecond: item.lawUnitSecond, // 法二单位
                            itemNo:item.itemNo, // 项号
                            boxNo:item.boxNo, // 箱号
                            skuNo: item.skuNo, // 商品料号
                            totalQty1: item.totalQty1,
                            totalQty2: item.totalQty2,
                            totalDecAmount: item.totalDecAmount, // 总价（申报金额）
                            ckAmount: item.totalDecAmount, // 总价（申报金额）
                            totalNetWeight: item.totalNetWeight, // 净重
                            totalDecNum: item.totalDecNum, // 申报数量
                            totalFirstNum: item.totalFirstNum ? item.totalFirstNum : '', // 法一数
                            totalSecondNum: item.totalSecondNum ? item.totalSecondNum : '', // 法二数
                            decPrice:item.decPrice,
                            ckPrice:item.decPrice,
                            createDate:item.createDate,
                            cusDeclNo:item.cusDeclNo,
                            invDecNo:item.invDecNo,
                            customer:item.customer,
                            isBonded:item.isBonded,
                            handbook:item.handbook,
                            note:item.note,
                        }
                        // 如果货物名称包含硫磺则赋值lot号
                        if (item.goodsName.indexOf('硫磺') > -1 && item.lotKgs) {
                            params.lotNo = item.lotNo
                            params.lotKgs = item.lotKgs
                            params.lotOrderNo = item.lotOrderNo
                            params.lotMaterialNo = item.lotMaterialNo
                        }
                        return clean(params)
                    })
                    await this.$api.insOutRecordBatch(this.outboundForm.id,newParamsList);
                    this.$message.success('保存成功');
                    this.inventoryTableCheckbox = []
                    // 并行执行查询操作
                    await Promise.all([
                        setTimeout(() => {
                            this.getWMSTaskDetail(this.outboundForm.id),
                            this.inventorySeach()
                        }, 500),
                    ]);
                }).catch(() => {
                })
            }catch (error) {
                // this.$message.error('保存失败');
            }
        },
        // 确定添加出库计划
        async saveAddInventoryPlan(){
            try {
                const valid = await new Promise((resolve) => {
                    this.$refs.inventoryPlanForm.validate((valid) => {
                        resolve(valid);
                    });
                });
                if (!valid) {
                    this.$message.error('请填写必填字段');
                    return false;
                }
                // 判断是否保存表头，没保存则先保存表头，保存表头后保存表体
                if( this.outboundForm.billNo === ''){
                    this.outboundForm.billNo = await this.getWMSBillNo()
                }
                // 判断表头的账册、仓库、保税类型、货主是否有值
                if (this.outboundForm.handbook === '' && this.outboundForm.ckName === '' && this.outboundForm.isBonded === '' && 
                    this.outboundForm.ownerName === '') {
                    this.outboundForm.handbook = this.inventorySelected.handbook
                    this.outboundForm.ckName = this.inventorySelected.ckName
                    this.outboundForm.isBonded = this.inventorySelected.isBonded
                    this.outboundForm.ownerName = this.inventorySelected.ownerName
                    // 等待保存表头完成
                    const res = await this.$api.saveMain(this.outboundForm);
                    this.outboundForm.id = res
                    if (localStorage.getItem('id')) {
                        localStorage.setItem('id', res);
                    }
                }
                // 保存表头后保存出库计划
                const params = {
                    taskType:'出库',
                    rowStatus: '', // 状态   
                    blNo: this.inventorySelected.blNo, // 提单号
                    interId: this.outboundForm.id, // 父id
                    goodsType: this.inventorySelected.goodsType, // 货物类型
                    hsCode: this.inventorySelected.hsCode, // 海关编码
                    goodsName: this.inventorySelected.goodsName, // 货物名称
                    spec: this.inventorySelected.spec, // 规格型号
                    ownerName: this.inventorySelected.ownerName, // 货主
                    ckName: this.inventorySelected.ckName, // 仓库
                    place: this.inventorySelected.place, // 库区
                    location: this.inventorySelected.location, // 库位
                    qty1Unit: this.inventorySelected.qty1Unit, // 件数1单位
                    qty2Unit: this.inventorySelected.qty2Unit, // 件数2单位
                    // packageType:this.inventorySelected.packageType, // 包装   库存没包装
                    decUnit: this.inventorySelected.decUnit, // 申报单位代码
                    decCurrency: this.inventorySelected.decCurrency, // 币制
                    stockDate:this.inventorySelected.createDate ,// 入库日期
                    originCountry:this.inventorySelected.originCountry, // 原产地 
                    lawUnitFirst: this.inventorySelected.lawUnitFirst, // 法一单位
                    lawUnitSecond: this.inventorySelected.lawUnitSecond, // 法二单位
                    itemNo:this.inventorySelected.itemNo, // 项号
                    boxNo:this.inventorySelected.boxNo, // 箱号
                    skuNo: this.inventorySelected.skuNo, // 商品料号
                    totalQty1: this.inventoryPlanForm.qty1,
                    totalQty2: this.inventoryPlanForm.qty2,
                    totalDecAmount: this.inventoryPlanForm.decAmount, // 总价（申报金额）
                    ckAmount: this.inventoryPlanForm.ckAmount, // 总价（申报金额）
                    totalNetWeight: this.inventoryPlanForm.netWeight, // 净重
                    totalDecNum: this.inventoryPlanForm.decNum, // 申报数量
                    totalFirstNum: this.inventoryPlanForm.firstNum ? this.inventoryPlanForm.firstNum : '', // 法一数
                    totalSecondNum: this.inventoryPlanForm.secondNum ? this.inventoryPlanForm.secondNum : '', // 法二数
                    decPrice:this.inventoryPlanForm.decPrice,
                    ckPrice:Number(this.inventoryPlanForm.ckPrice),
                    createDate:this.inventorySelected.createDate,
                    cusDeclNo:this.inventorySelected.cusDeclNo,
                    invDecNo:this.inventorySelected.invDecNo,
                    customer:this.inventorySelected.customer,
                    isBonded:this.inventorySelected.isBonded,
                    handbook:this.inventorySelected.handbook,
                    note:this.inventorySelected.note,
                }
                // 如果货物名称包含硫磺则赋值lot号
                if (this.inventorySelected.goodsName.indexOf('硫磺') > -1 && this.inventorySelected.lotKgs) {
                    params.lotNo = this.inventorySelected.lotNo
                    params.lotKgs = this.inventoryPlanForm.netWeight
                    params.lotOrderNo = this.inventorySelected.lotOrderNo
                    params.lotMaterialNo = this.inventorySelected.lotMaterialNo
                }
                const paramsArr = []
                paramsArr.push(clean(params))
                // const redID = await this.$api.insOneRecordWMSTask(params);
                await this.$api.insOutRecordBatch(this.outboundForm.id,paramsArr);
                this.$message.success('保存成功');
                // 扣除库存
                // await this.wmsOutStock(redID);
                // 并行执行查询操作
                await Promise.all([
                    setTimeout(() => {
                        this.getWMSTaskDetail(this.outboundForm.id),
                        this.inventorySeach()
                    }, 500),
                ]);
                // 关闭弹窗
                this.inventoryPlanClose();
            } catch (error) {
                console.log(error);
                // this.$message.error('保存失败');
            }
        },
        // 扣除库存
        wmsOutStock(redID){
            const {totalDecAmount,totalDecNum,totalFirstNum,totalNetWeight,totalQty1,totalQty2,totalSecondNum,_X_ROW_KEY, ...rest} = this.inventorySelected
            const params = {
                ...rest,
                subId: redID,
                taskNo: this.outboundForm.billNo,
                qty1: this.inventoryPlanForm.qty1 * -1,
                qty2: this.inventoryPlanForm.qty2 ? this.inventoryPlanForm.qty2 * -1 : '',
                decAmount: this.inventoryPlanForm.decAmount  * -1, // 总价（申报金额）
                netWeight: this.inventoryPlanForm.netWeight  * -1, // 净重
                decNum: this.inventoryPlanForm.decNum  * -1, // 申报数量
                firstNum: this.inventoryPlanForm.firstNum ? this.inventoryPlanForm.firstNum  * -1 : '',
                secondNum: this.inventoryPlanForm.secondNum ? this.inventoryPlanForm.secondNum  * -1 : '',
            }
            this.$api.wmsOutStock(params).then(res =>{})
        },
        // 计划信息列表多选
        outboundPlanRowsCheckbox(){
            const selectedRecords = this.$refs.outboundPlanTable.getCheckboxRecords();
            this.outboundPlanCheckbox = selectedRecords
            // 深拷贝一个用来修改下发件数等信息
            this.outboundPlanCheckboxExitRow = JSON.parse(JSON.stringify(selectedRecords))
        },
        // 货物行选中
        inWarehouseRowsChange( { row }){
            // 查询下发任务列表
            this.wmsGetOpsBySubId(row.id)
        },
        // 查询下发任务列表，单个
        wmsGetOpsBySubId(id){
            this.$api.wmsGetOpsBySubId(id).then(res =>{
                this.IssueGoodsData = res
            })
        },
        // 查询所有下发任务
        getIssueAll(){
            this.$api.wmsGetOpsByTaskId(this.outboundForm.id).then(res =>{
                this.IssueGoodsData = res
                // 货物信息列表取消选中
                this.$refs.outboundPlanTable.clearRadioRow()
            })
        },
        // 下发暂存
        async IssueRowsSave(){
            // 判断是否选中行数据
            if( !this.outboundPlanCheckbox.length ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            const hasInvalidStatus = this.outboundPlanCheckbox.some(item => {
                return item.rowStatus === '已指派' || item.rowStatus === '完成';
            });
            
            if (hasInvalidStatus) {
                this.$message.warning('包含已指派或完成状态的数据，不可下发暂存');
                return false;
            }
            // 将下发信息的净重和件数修改为可以下发的最大值
            this.outboundPlanCheckboxExitRow.forEach((row, index) => {
                row.decAmount = this.outboundPlanCheckbox[index].decAmount ? parseFloat(this.outboundPlanCheckbox[index].decAmount) - parseFloat(this.outboundPlanCheckbox[index].workedAmount) :''
                // this.issueGoodsForm.vol = this.inWarehouseRows.vol ? parseFloat(this.inWarehouseRows.vol) - parseFloat(this.inWarehouseRows.workedVol) : ''
                row.netWeight = parseFloat(this.outboundPlanCheckbox[index].netWeight) - parseFloat(this.outboundPlanCheckbox[index].workedNetWeight)
                row.decNum = this.outboundPlanCheckbox[index].decNum? parseFloat(this.outboundPlanCheckbox[index].decNum) - parseFloat(this.outboundPlanCheckbox[index].workedDecNum) :''
                row.firstNum = parseFloat(this.outboundPlanCheckbox[index].firstNum) - parseFloat(this.outboundPlanCheckbox[index].workedFirstNum)
                row.secondNum = this.outboundPlanCheckbox[index].secondNum ? parseFloat(this.outboundPlanCheckbox[index].secondNum) - parseFloat(this.outboundPlanCheckbox[index].workedSecondNum) : ''
                row.qty1 = parseFloat(this.outboundPlanCheckbox[index].qty1) - parseFloat(this.outboundPlanCheckbox[index].workedQty1)
                row.qty2 =  this.outboundPlanCheckbox[index].qty2 ?  parseFloat(this.outboundPlanCheckbox[index].qty2) - parseFloat(this.outboundPlanCheckbox[index].workedQty2) : ''
            })
            //  检查货物名称中是否包含硫磺（如果有需要）
            const hasSulfur = this.outboundPlanCheckbox.some(item => 
                item.goodsName && item.goodsName.includes('硫磺')
            );
            // 有硫磺则显示表格列
            if (hasSulfur) {
                this.issueGoodsLOTColumn = true
            }
            await this.$nextTick()
            this.IssueGoodsVisible = true
        },
        // 下发暂存输入件数1后，修改净重\件数2、申报数量、法一、法二、申报金额
        // 修改作业行信息中的件数1，顺便修改件数2、净重、法1、法2、申报金额、申报重量
        IssueGoodsRowQty1Blur(row ,index){
            // 判断当前件数1是否超过
            if(row.qty1 > this.outboundPlanCheckbox[index].qty1){
                this.$message.warning(`大于计划件数1 ，请调整！`);
                row.qty1 = ''
                return false
            }
            row.qty2 = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].qty2,this.outboundPlanCheckbox[index].qty1,row.qty1)
            row.netWeight = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].netWeight,this.outboundPlanCheckbox[index].qty1,row.qty1)
            row.decNum = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].decNum,this.outboundPlanCheckbox[index].qty1,row.qty1)
            row.decAmount = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].decAmount,this.outboundPlanCheckbox[index].qty1,row.qty1)
            row.firstNum = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].firstNum,this.outboundPlanCheckbox[index].qty1,row.qty1)
            row.secondNum = this.calculateAllPlanFields(this.outboundPlanCheckbox[index].secondNum,this.outboundPlanCheckbox[index].qty1,row.qty1)
        },
        // 识别小票成功：车牌、箱号、铅封号、司机回填到任务下发表单，没识别到的字段不覆盖手填内容
        fillIssueGoodsByCarBox(data){
            if(!data){
                return false
            }
            if(data.truckNo){
                this.issueGoodsForm.truckNo = data.truckNo
            }
            if(data.boxNo){
                this.issueGoodsForm.boxNo = data.boxNo
            }
            if(data.sealNo){
                this.issueGoodsForm.sealNo = data.sealNo
            }
            if(data.driver){
                this.issueGoodsForm.driver = data.driver
            }
            // 车牌是远程搜索下拉，回填后把候选拉出来，方便用户核对司机
            if(data.truckNo){
                this.truckNoRemoteMethod(data.truckNo)
            }
        },
        // 关闭下发暂存弹出框
        IssueGoodsClose(){
            this.IssueGoodsVisible = false
            this.issueGoodsLOTColumn = false
            this.$refs.issueGoodsForm.resetFields();
            // 清掉这次识别的小票图片，避免带到下一单
            if(this.$refs.parseTicket){
                this.$refs.parseTicket.reset();
            }
            this.issueGoodsForm.decAmount = 0
        },
        // 保存前校验填写的车牌是否已录入车辆列表，没有则自动新增（电话空着），再继续下发
        async checkCarBeforeIssue(){
            const carNo = (this.issueGoodsForm.truckNo || '').trim()
            if(!carNo){
                return
            }
            let res = []
            try {
                res = await this.$api.wmsGetCarInfo(carNo) || []
            } catch (e) {
                // 查询失败必须给出提示，不能无声无息地中断保存
                this.$message.error('查询车辆信息失败，请重试')
                throw e
            }
            // 接口返回的不是数组按空处理，避免下面判断报错把保存悄悄打断
            if(!Array.isArray(res)){
                res = []
            }
            // 车牌已在车辆列表里，直接继续
            if(res.length){
                return
            }
            // 车牌不在车辆列表里，自动新增一条，电话空着
            await this.$api.wmsInsCar({
                carNo: carNo,
                driver: this.issueGoodsForm.driver || '',
                driverPhone: '',
            })
            this.$message({
                message: '车牌 ' + carNo + ' 不在车辆列表中，已自动新增',
                type: 'success'
            })
        },
        // 保存下发暂存任务弹窗
        async saveIssueGoods(){
            // 判断
            this.$refs.issueGoodsForm.validate(async (valid) => {
                if (valid) {
                    const validationErrors = await this.validateTable()
                    if (validationErrors.length > 0) {
                        // 显示错误信息
                        this.$message.warning('请填写完整件数1、件数2、净重、申报数量、申报金额等数值')
                        return false
                    }
                    // 先校验车牌，不在车辆列表里就自动新增
                    await this.checkCarBeforeIssue()
                    // 执行保存函数
                    await this.wmsSaveOpTask();
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 验证表格输入
        validateTable() {
            const errors = []
            this.outboundPlanCheckboxExitRow.forEach((row, index) => {
                // 验证 qty1
                if (this.isEmptyOrZero(row.qty1)) {
                    errors.push(`第${index + 1}行：件数1不能为空且不能为0`)
                }
                // 验证 qty2（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.qty2  && this.isEmptyOrZero(row.qty2)) {
                    errors.push(`第${index + 1}行：件数2不能为空且不能为0`)
                }
                // 验证 netWeight（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.netWeight && this.isEmptyOrZero(row.netWeight)) {
                    errors.push(`第${index + 1}行：净重不能为空且不能为0`)
                }
                // 验证 decNum（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.decNum && this.isEmptyOrZero(row.decNum)) {
                    errors.push(`第${index + 1}行：申报数量不能为空且不能为0`)
                }
                // 验证 decAmount（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.decAmount && this.isEmptyOrZero(row.decAmount)) {
                    errors.push(`第${index + 1}行：申报申报金额不能为空且不能为0`)
                }
                // 验证 firstNum（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.firstNum && this.isEmptyOrZero(row.firstNum)) {
                    errors.push(`第${index + 1}行：法一数量不能为空且不能为0`)
                }
                // 验证 secondNum（如果启用）
                if (!!this.outboundPlanCheckboxExitRow[index]?.secondNum && this.isEmptyOrZero(row.secondNum)) {
                    errors.push(`第${index + 1}行：法二数量不能为空且不能为0`)
                }
            })
            
            return errors
        },
        isEmptyOrZero(value) {
            // 检查是否为空或为0
            return value === '' || value === null || value === undefined || 
                value === 0 || value === '0' || value === 0.0 || 
                (typeof value === 'string' && value.trim() === '')
        },
        wmsSaveOpTask(){
            // 表头赋值
            // 选中行id组合 ,分割
            var combinationId = this.outboundPlanCheckboxExitRow.map(item => item.id).join(',')
            this.issueGoodsForm.interId = combinationId
            this.issueGoodsForm.createUser = this.outboundForm.createUser
            this.issueGoodsForm.handbook = this.outboundForm.handbook
            this.issueGoodsForm.ckName = this.outboundForm.ckName
            this.issueGoodsForm.blNo = this.outboundForm.blNo
            this.issueGoodsForm.cusDeclNo = this.outboundForm.cusDeclNo
            this.issueGoodsForm.invDecNo = this.outboundForm.invDecNo
            this.issueGoodsForm.isBonded = this.outboundForm.isBonded
            // this.issueGoodsForm.boxType = this.outboundForm.boxType
            // this.issueGoodsForm.boxNum = this.outboundForm.boxNum
            this.issueGoodsForm.ownerName = this.outboundForm.ownerName
            this.issueGoodsForm.qty1 = this.outboundPlanCheckboxExitRow.reduce((sum, item) =>  {
                // 安全地转换为数字
                const qty = parseFloat(item.qty1);
                return sum + (isNaN(qty) ? 0 : qty);
            }, 0);
            this.issueGoodsForm.netWeight = this.outboundPlanCheckboxExitRow.reduce((sum, item) => {
                // 安全地转换为数字
                const netWeight = parseFloat(item.netWeight);
                return sum + (isNaN(netWeight) ? 0 : netWeight);
            }, 0) 
            // 货物名称合并去重
            this.issueGoodsForm.goodsName =  [...new Set(this.outboundPlanCheckboxExitRow.map(item => item.goodsName))].join(',')
            this.issueGoodsForm.childList = this.outboundPlanCheckboxExitRow.map(item => {
                const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                completeDate,completeTime,createDate,createTime,rowStatus, ...rest } = item;
                rest.interId = item.id // 组合id
                rest.taskType = '出库作业'
                // 将仓库,报关单号,核注清单号,客户,货主赋值给rest
                rest.ckName = this.outboundForm.ckName
                // rest.cusDeclNo = this.outboundForm.cusDeclNo
                // rest.invDecNo = this.outboundForm.invDecNo
                rest.customer = this.outboundForm.customer
                rest.ownerName = this.outboundForm.ownerName
                rest.handbook = this.outboundForm.handbook
                rest.isBonded = this.outboundForm.isBonded
                rest.storekeeper = this.issueGoodsForm.storekeeper
                return clean(rest);
            });
            this.$api.wmsSaveOpTask( this.issueGoodsForm ).then(res =>{
                // 关闭弹窗
                this.IssueGoodsClose()
                // 重新查询主任务
                this.getWMSTaskDetail(this.outboundForm.id)
                // 查询下发任务列表
                this.wmsGetOpsBySubId(this.outboundPlanCheckboxExitRow[0].id)
                // 清空表格选中
                this.inventoryPlanRow = {}
                this.outboundPlanCheckbox = [], // 计划信息多选表格
                this.outboundPlanCheckboxExitRow = [], // 用来进行修改
                this.$refs.outboundPlanTable.resetFields();
            })
        },
        // 删除出库计划
        // async deleteOutboundPlan( row ){
        //     // 判断是否选中行数据
        //     // 判断选中计划信息是否可以下发暂存
        //     if(row.rowStatus !== '新建' ){ 
        //         this.$message({
        //             message: '此计划信息不可删除',
        //             type: 'warning'
        //         });
        //         return false
        //     }

        //     this.$confirm('是否删除此计划?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.$api.wmsRemoveDetailById(row.id).then( async res =>{
        //             this.$message({
        //                 type: 'success',
        //                 message: '删除成功!'
        //             })
        //             // 还原lot号
        //             // await this.wmsunDoLots(row.id)
        //             // 取消选中信息行
        //             // this.inventoryPlanRow = {}
        //             // 刷新页面
        //             await this.getWMSTaskDetail(this.outboundForm.id)
        //             // 刷新库存 如果库存查询中输入提单号或报关单号就查，否则不查
        //             // if(this.inventorySeachForm.blNo === '' &&  this.inventorySeachForm.cusDeclNo === '' &&  this.inventorySeachForm.boxNo === ''){
        //             //     return
        //             // }else{
        //                 await this.inventorySeach()
        //             // }
        //         })
        //     })
        // },
        // 批量删除出库计划
        batchDeleteOutboundPlan(){
            // 判断是否选中行数据
            if( !this.outboundPlanCheckbox.length ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            const hasInvalidStatus = this.outboundPlanCheckbox.some(item => {
                return item.rowStatus === '已指派' || item.rowStatus === '完成';
            });
            
            if (hasInvalidStatus) {
                this.$message.warning('包含已指派或完成状态的数据，不可删除');
                return false;
            }
                // wmsRemoveDetails
            this.$confirm('是否删除此计划?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = this.outboundPlanCheckbox.map(item => item.id)
                this.$api.wmsRemoveDetails(params).then( async res =>{
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    // 刷新页面
                    await this.getWMSTaskDetail(this.outboundForm.id)
                    // 清空库存表格
                    this.inventoryList = []
                    // await this.inventorySeach()
                })
            })
        },
        // // 还原计划信息lot号
        // wmsunDoLots(id){
        //     this.$api.wmsunDoLots(id)
        // },
        // 点作业详情操作列的证件验证：先校验这一行的作业任务，再打开高拍仪
        openLicenseVerify(row){
            // 验证通过后不允许再次验证
            if(this.isLicenseVerified(row)){
                this.$message({
                    type: 'warning',
                    message: '该作业任务证件已验证通过，不需要重复验证！'
                });
                return false
            }
            if(!row.driver || !row.truckNo){
                this.$message({
                    type: 'warning',
                    message: '该作业任务的司机或车牌为空，请先编辑补全再验证！'
                });
                return false
            }
            // 记下这次要验证的作业任务，拍照回来后要用它的作业单id、司机、车牌
            this.licenseTaskRow = row
            this.$refs.LicenseDialog.dialogFormVisible = true;
            // 弹窗打开后再初始化高拍仪，和拍摄证件的写法保持一致
            this.$nextTick(() => { this.$refs.LicenseDialog.getCompetence(); })
        },
        // 高拍仪拍完照：只取第一张，调证件验证接口
        handleLicensePhoto(fileList){
            const row = this.licenseTaskRow
            if(!fileList || !fileList.length || !row || !row.id){
                return false
            }
            const maxCount = 2;
            if(fileList.length > maxCount){
                this.$message.warning('一次最多只验证两张，已取前两张！');
            }
            const formData = new FormData();
            formData.append('file', fileList[0].raw);
            // 第二张：file2（可选）
            if (fileList.length > 1) {
                formData.append('file2', fileList[1].raw);
            }

            // 查询参数：作业单id + 待比对的司机姓名、车牌号
            const query = {
                taskId: row.id,
                driverName: row.driver,
                plateNo: row.truckNo
            }
            this.$api.wmsRecognizeLicense(query, formData).then(res => {
                // 显示接口返回的提示
                this.$alert(this.getLicenseTip(res), '证件验证结果', {
                    confirmButtonText: '确定'
                });
                // 重新刷新作业信息
                this.refreshIssueGoods(row)
            }).catch(() => {
                // 接口报错 request.js 已经统一提示，这里只保证流程能结束
            })
        },
        // 取接口返回的提示文字，兼容字符串和对象两种返回
        getLicenseTip(res){
            if(typeof res === 'string' && res){
                return res
            }
            if(res && typeof res === 'object'){
                const key = ['message','msg','tip','result','content','data'].find(item => {
                    return typeof res[item] === 'string' && res[item]
                })
                if(key){
                    return res[key]
                }
                return JSON.stringify(res)
            }
            return '证件验证完成'
        },
        // 证件状态：后端返回"已验证"才算验证通过，空/0/未验证都算没通过
        isLicenseVerified(row){
            if(!row){
                return false
            }
            const status = row.licenseStatus
            if(status === undefined || status === null || status === ''){
                return false
            }
            const text = String(status).trim()
            return text === '已验证'
        },
        // 点证件状态里的"已验证"：先查这个作业任务上传的证件照片，再直接打大图
        showLicensePhoto(row){
            if(!row || !row.id){
                this.$message({
                    type: 'warning',
                    message: '这条作业任务没有作业单id，查不到证件照片！'
                });
                return false
            }
            this.licensePhotoList = []
            this.$api.wmsGetDriverPhotoBy(row.id).then(res => {
                this.licensePhotoList = this.getPhotoUrls(res)
                if(!this.licensePhotoList.length){
                    this.$message({
                        type: 'warning',
                        message: '没有查询到证件照片！'
                    });
                    return
                }
                // 借用 el-image 自带的查看大图：点背景或右上角关闭，支持滚轮缩放、ESC
                this.$nextTick(() => {
                    const preview = this.$refs.licensePreview
                    if(preview && typeof preview.clickHandler === 'function'){
                        preview.clickHandler()
                    }else if(preview && preview.$el && preview.$el.querySelector('img')){
                        preview.$el.querySelector('img').click()
                    }else{
                        this.$message({
                            type: 'warning',
                            message: '当前版本不支持大图预览！'
                        });
                    }
                })
            }).catch(() => {
                // 接口报错 request.js 已经统一提示
            })
        },
        // 接口返回的照片地址统一成数组（兼容 单个url / url数组 / 逗号拼接 / 带字段的对象）
        getPhotoUrls(res){
            let list = []
            if(typeof res === 'string'){
                list = res.split(',')
            }else if(Array.isArray(res)){
                list = res
            }else if(res && typeof res === 'object'){
                const key = ['url','urls','imgUrl','photoUrl','fileUrl','path','list','data'].find(item => res[item])
                if(key){
                    return this.getPhotoUrls(res[key])
                }
            }
            return list.map(item => {
                const url = typeof item === 'string' ? item : (item && (item.url || item.fileUrl || item.path))
                return this.fixPhotoUrl(url)
            }).filter(item => item)
        },
        // 后端返回相对路径时补上接口域名
        fixPhotoUrl(url){
            if(!url){
                return ''
            }
            if(/^(http|https|data:|blob:)/i.test(url)){
                return url
            }
            const base = process.env.VUE_APP_BASE_API || ''
            return base.replace(/\/$/, '') + (url.charAt(0) === '/' ? url : '/' + url)
        },
        // 证件验证完成后刷新作业信息（作业详情是按计划信息的 interId 查的）
        refreshIssueGoods(row){
            // 验证完清掉验证目标，避免下次拍照还拿着刷新前的旧行
            this.licenseTaskRow = {}
            let interId = row && row.interId ? row.interId : ''
            if(interId && typeof interId === 'string' && interId.includes(',')){
                interId = interId.split(',')[0].trim()
            }
            if(interId){
                this.wmsGetOpsBySubId(interId)
            }else{
                // 拿不到计划信息id就退化成查这个任务单下所有的作业
                this.getIssueAll()
            }
        },
        // 下发任务到手持端
        IssueRows(row){
            // 证件没验证通过不允许下发
            // if(!this.isLicenseVerified(row)){
            //     this.$message({
            //         type: 'warning',
            //         message: '该作业任务证件未验证通过，不允许下发！'
            //     });
            //     return false
            // }
            this.$confirm('是否推送作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmspushOpTask(row.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                })
            }).catch(() => {      
            });
        },
        // 完成出库
        completeRows(row){
            // 打开完成弹窗
            this.viewCompleteworkVisible = true
            this.completeworkRow = row
        },
        // 查看完成状态下的作业详情
        getCompleteDetails(row){
            this.viewCompleteworkVisible = true
            this.completeworkRow = row
        },
        // 关闭查看完成状态下的作业详情
        viewCompleteworkClose(id){
            this.viewCompleteworkVisible = false
            this.completeworkRow = {}
            // 刷新页面
            let interId = id;
            if (interId && typeof interId === 'string' && interId.includes(',')) {
                interId = interId.split(',')[0].trim();
            }
            // 清空库存表格
            this.inventoryList = []
            this.wmsGetOpsBySubId(interId)
            this.getWMSTaskDetail(this.outboundForm.id)
            
        },
         // 打印
        report(command, row){
            // 根据不同的 command 执行不同的打印逻辑
            switch (command) {
                case '出库受理单':
                    this.printAcceptance(row);
                    break;
                case '出门证':
                    this.printOut(row);
                    break;
                default:
                    this.$message.warning('未知的打印类型');
            }
        },
        // 打印出库受理单
        async printAcceptance(row) {
            try {
                // 查询用户电话
                const storekeeperInformation =  await this.$api.getUserInfo( row.storekeeper )
                // 处理表格数据
                const tableTask = row.childList.map(item => ({
                    ...item,
                    // completeTime: item.completeTime ? item.completeTime.split('T')[0] + '  ' + item.completeTime.split('T')[1] : '',
                    qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                    qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList),
                    placeLocation: `${item.place || ''}-${item.location || ''}`,
                }));
                 //  检查货物名称中是否包含硫磺（如果有需要）
                const LHhasSulfur = row.childList.some(item => 
                    item.goodsName && item.goodsName.includes('硫磺')
                );
                const ZJhasSulfur = row.childList.some(item => 
                    item.ownerName && item.ownerName.includes('建发')
                    // item.goodsName && item.goodsName.includes('纸浆')
                    
                );
                // console.log(row.childList);
                // const manJson = require('../../grf/出库受理单.json');
                const master = {
                    driver:row.driver,
                    truckNo:row.truckNo,
                    boxNo:row.boxNo,
                    sealNo:row.sealNo,
                    remark: row.note + (this.outboundForm.remark ? this.outboundForm.remark : ''),
                    createUser:this.outboundForm.createUser,
                    storekeeperPhone:storekeeperInformation.phone,
                    storekeeper:row.storekeeper,
                    LOTShow:LHhasSulfur,
                    ZJShow:!ZJhasSulfur,
                    ckBlNo:this.outboundForm.blNo,
                };
                const params = { 
                    master: master, 
                    table: tableTask 
                };
                var args = {
                    report: urlAddRandomNo("/grf/出库受理单.grf"),
                    data: params,
                    type: "preview",
                };
                webapp_ws_ajax_run(args);
            } catch (error) {
                console.error('打印处理失败:', error);
            }
        },
        // 打印出门证
        printOut(row){
            if(row.rowStatus !== '完成'){
                this.$message.warning('此出库作业没有完成，不可打印出门证');
                return false
            }
            try {
                let LHhasSulfur = false; // 硫磺
                let ZJhasSulfur = false; // 纸浆
                row.childList.forEach(item => {
                    const name = item.goodsName || '';
                    const ownerName = item.ownerName || '';
                    if (name.includes('硫磺')) LHhasSulfur = true;
                    // if (name.includes('纸浆')) ZJhasSulfur = true;
                    if (ownerName.includes('建发')) ZJhasSulfur = true;
                });
                let tableTask = [];
                // 如果是硫磺则合并
                if(LHhasSulfur){
                    // 货物名称和规格型号一样合并
                    const groupMap = new Map();
                    row.childList.forEach(item => {
                        // 分组唯一标识：goodsName + spec + qty1Unit 拼接
                        const groupKey = `${item.goodsName}_${item.spec}_${item.qty1Unit}`;
                        if (groupMap.has(groupKey)) {
                            // 已有分组，累加数量、净重
                            const target = groupMap.get(groupKey);
                            target.qty1 += item.qty1;
                            target.netWeight += item.netWeight;
                        } else {
                            // 新建分组对象
                            groupMap.set(groupKey, {
                                goodsName: item.goodsName,
                                qty1Unit: item.qty1Unit,
                                qty1: item.qty1,
                                netWeight: item.netWeight
                            });
                        }
                    })
                    tableTask = Array.from(groupMap.values()).map(item => ({
                        ...item,
                        note: row.opNote,
                        createUser:row.createMan,
                        truckNo:row.truckNo,
                        // completeTime: item.completeTime ? item.completeTime.split('T')[0] + '  ' + item.completeTime.split('T')[1] : '',
                        qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList)
                    }))
                }else{
                    tableTask = row.childList.map(item => ({
                        ...item,
                        note: row.opNote,
                        createUser:row.createMan,
                        truckNo:row.truckNo,
                        // completeTime: item.completeTime ? item.completeTime.split('T')[0] + '  ' + item.completeTime.split('T')[1] : '',
                        qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                    }));
                }
                const master = {
                    ZJShow:!ZJhasSulfur,
                }
                const params = { 
                    master: master, 
                    table: tableTask 
                };
                var args = {
                    report: urlAddRandomNo("/grf/出门证.grf"),
                    data: params,
                    type: "preview",
                };
                webapp_ws_ajax_run(args);
            } catch (error) {
                console.error('打印处理失败:', error);
            }

        },
        // 通知父级页面
        notifyParentBeforeUnload(){
            if (window.opener) {
                const targetOrigin =  localStorage.getItem('parentOrigin')
                window.opener.postMessage(
                    { 
                        type: 'WINDOW_CLOSED',
                        value: true,
                    },
                    targetOrigin
                );
            }   
        },
        setupMessageListener() {
            // 监听父页面发送的消息
            window.addEventListener('message', (event) => {
                // 验证消息来源（可选，增加安全性）
                if (event.origin !== window.location.origin) {
                // 如果不是同源消息，可以忽略或处理
                }
                if (event.data.type === 'CLOSE_WINDOW_FROM_PARENT') {
                    window.close();
                }
            });
        },
        // 核放单号只有在【七星河路仓库 + 保税】时才允许填写，不符合条件时清空
        clearCheckNoWhenNotAllowed(){
            if (!(this.outboundForm.ckName === '七星河路仓库' && this.outboundForm.isBonded === '保税')) {
                this.outboundForm.checkNo = ''
            }
        },
        // 获取任务单附件
        async taskMainFiles(){
            if (!this.outboundForm.id) {
                this.$message({
                    type: 'warning',
                    message: '请先保存任务'
                })
                return
            }
            this.taskMainFilesLoading = true
            try {
                const res = await this.$api.wmsGetTaskMainFiles(this.outboundForm.id)
                const list = res || []
                // 没有附件就不弹窗，直接提示
                if (!list.length) {
                    this.$message({
                        type: 'warning',
                        message: '该任务单暂无附件'
                    })
                    return
                }
                this.taskMainFilesList = list
                this.taskMainFilesVisible = true
            } catch (error) {
                console.log('获取任务单附件失败，但不显示提示', error)
            } finally {
                this.taskMainFilesLoading = false
            }
        },
        // 查看任务单附件
        viewTaskMainFile(row){
            if (row.filePath) {
                window.open(row.filePath)
            }
        },
        // 关闭任务单附件弹窗
        taskMainFilesClose(){
            this.taskMainFilesVisible = false
            this.taskMainFilesList = []
        },
        // 打开核放单识别弹窗（【七星河路仓库 + 保税】且表头已保存才允许）
        openCheckReleaseParse(){
            // 表头没保存过（没有id）不允许识别
            if (!this.outboundForm.id) {
                this.$message({
                    type: 'warning',
                    message: '请先保存任务'
                })
                return
            }
            if (this.outboundForm.ckName !== '七星河路仓库' || this.outboundForm.isBonded !== '保税' || this.editConfig) {
                return
            }
            this.checkReleaseVisible = true
        },
        // 核放单识别：选文件/拖文件（校验类型，只允许图片或PDF）
        checkReleaseFileChange(file){
            const raw = file.raw
            if (!raw) {
                return
            }
            const isImage = raw.type && raw.type.indexOf('image/') === 0
            const isPdf = raw.type === 'application/pdf' || /\.pdf$/i.test(raw.name)
            if (!isImage && !isPdf) {
                this.$message({
                    type: 'warning',
                    message: '只能上传核放单图片或PDF'
                })
                this.checkReleaseFileRaw = null
                this.checkReleaseFileList = []
                this.$refs.checkReleaseUpload.clearFiles()
                return
            }
            this.checkReleaseFileRaw = raw
        },
        // 核放单识别：超出个数限制时用新文件替换旧文件
        checkReleaseFileExceed(files){
            this.$refs.checkReleaseUpload.clearFiles()
            this.$refs.checkReleaseUpload.handleStart(files[0])
        },
        // 核放单识别：移除已选文件
        checkReleaseFileRemove(){
            this.checkReleaseFileRaw = null
        },
        // 点识别：把文件传给AI接口，识别成功回填核放单号
        checkReleaseParse(){
            if (!this.checkReleaseFileRaw) {
                this.$message({
                    type: 'warning',
                    message: '请先选择核放单图片或PDF'
                })
                return
            }
            const formData = new FormData()
            formData.append('file', this.checkReleaseFileRaw)
            this.checkReleaseLoading = true
            this.$api.wmsAiCheckReleaseParse(formData,{taskId:this.outboundForm.id}).then(res => {
                const checkNo = res && res.checkNo
                if (checkNo) {
                    this.outboundForm.checkNo = checkNo
                    if (this.$refs.outboundForm) {
                        this.$refs.outboundForm.clearValidate(['checkNo'])
                    }
                    this.checkReleaseClose()
                } else {
                    this.$message({
                        type: 'warning',
                        message: '未识别到核放单号，请换个清晰的图片再试'
                    })
                }
            }).catch(() => {
                // 接口报错 request.js 已经统一提示，这里只保证流程能结束
            }).finally(() => {
                this.checkReleaseLoading = false
            })
        },
        // 关闭核放单识别弹窗
        checkReleaseClose(){
            this.checkReleaseVisible = false
            this.checkReleaseFileList = []
            this.checkReleaseFileRaw = null
            if (this.$refs.checkReleaseUpload) {
                this.$refs.checkReleaseUpload.clearFiles()
            }
        },
        // 完成任务，任务完成后不允许修改
        completeTask(){
            // 保税任务：保税 + 七星河路仓库时，贸易方式、运输工具名称、运输工具编号必填；
            // 另外【七星河路仓库 + 保税】时，核注清单号、报关单号、核放单号都要填写
            const mustFillList = []
            if (this.bondedFieldsRequired) {
                mustFillList.push(
                    { label: '贸易方式', value: this.outboundForm.tradeMode },
                    { label: '运输工具名称', value: this.outboundForm.trafName },
                    { label: '运输工具编号', value: this.outboundForm.voyNo },
                )
            }
            if (this.outboundForm.ckName === '七星河路仓库' && this.outboundForm.isBonded === '保税') {
                mustFillList.push(
                    { label: '核注清单号', value: this.outboundForm.invDecNo },
                    { label: '报关单号', value: this.outboundForm.cusDeclNo },
                    { label: '核放单号', value: this.outboundForm.checkNo },
                )
            }
            const emptyItem = mustFillList.find(item => !String(item.value == null ? '' : item.value).trim())
            if (emptyItem) {
                this.$message({
                    type: 'warning',
                    message: `请先填写${emptyItem.label}再结束任务`
                })
                return
            }
            this.$confirm('是否确定结束任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 结束接口
                this.$api.wmsFinishTask(this.outboundForm.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '任务结束成功!'
                    });
                    // 刷新页面
                    this.getWMSTaskDetail(this.outboundForm.id)
                    // 清空数据
                    this.IssueGoodsData = []
                    // 清空库存表格
                    this.inventoryList = []
                })
            }).catch(() => {
                
            });
        },
        // 撤销任务结束
        revokeCompleteTask(){
            this.$confirm('是否确定撤销结束?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 撤销接口
                this.$api.wmsUnDoTask(this.outboundForm.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '任务撤销成功!'
                    })
                     // 刷新页面
                    this.getWMSTaskDetail(this.outboundForm.id)
                    // 清空数据
                    this.IssueGoodsData = []
                })
            })
        },
        // 删除整单任务
        outboundDel(){
            this.$confirm('是否确定是删除此任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteWMSTask( this.outboundForm.id ).then(res =>{
                    this.$message.success('删除成功')
                    // 关闭此页面
                    window.close();
                })
            }).catch(() => { });  
        },
        // 删除作业信息
        async delIssueRows(row){
            this.$confirm('是否删除此作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 循环删除行信息
                try {
                    // 删除作业计划
                    this.$api.wmsDeleteJobById(row.id).then(res =>{
                        this.$message({
                            type: 'success',
                            message: '作业任务已删除'
                        });
                        // 更新数据
                        this.wmsGetOpsBySubId(row.interId)
                        this.getWMSTaskDetail(this.outboundForm.id)
                    })
                } catch (error) {
                    console.error('批量调用接口失败:', error);
                }
            })
        },
        // 上传图片导出（接口返回 zip 二进制流，用 blob 方式下载）
        async IMGListExport(){
            // 没有任务 id 时没必要请求
            if (!this.outboundForm.id) {
                this.$message({
                    type: 'warning',
                    message: '请先保存任务再导出图片'
                })
                return
            }
            try {
                // 拦截器里 blob 请求返回的是完整响应对象，只有这样才能拿到响应头里的文件名
                const response = await this.$api.wmsDownloadTaskZip(this.outboundForm.id)
                const blob = response.data instanceof Blob ? response.data : new Blob([response.data])
                // 后端报错时会返回 json（被包成了 blob），这里识别出来提示，不能当成压缩包下载
                if (blob.type && blob.type.indexOf('application/json') > -1) {
                    const result = JSON.parse(await blob.text())
                    this.$message({
                        type: 'error',
                        message: result.message || '图片导出失败'
                    })
                    return
                }
                // 文件名优先取响应头里的，取不到就用提单号
                let fileName = this.outboundForm.blNo ? this.outboundForm.blNo + '.zip' : '图片导出.zip'
                const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
                if (disposition) {
                    // 兼容 filename*=UTF-8''xxx.zip 和 filename="xxx.zip" 两种写法
                    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(disposition)
                    if (match && match[1]) {
                        fileName = decodeURIComponent(match[1])
                    }
                }
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = fileName
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                // 延迟释放，避免下载还没开始就把地址回收掉
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 1000)
            } catch (error) {
                console.log('下载失败，但不显示提示', error)
            }     
        },
        // 打开AI识别弹窗
        openAiParse(){
            this.$refs.AIRecognition.open()
        },
        // AI识别完成后端已落库，前端只查详情
        aiParseSaved(taskMainId){
            if (localStorage.getItem('id')) {      // 和 outboundSaveMain 的写法保持一致
                localStorage.setItem('id', taskMainId)
            }
            this.getWMSTaskDetail(taskMainId)      // 表头、明细、列定义、编辑状态一次全回来
            this.$message.success('识别成功')
        },
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.notifyParentBeforeUnload)

    },
}
</script>
<style style lang="less" scoped>
.width_100{
    width: 100%;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
.mini_button{
    padding: 3px 8px !important;
}
.outboundForm{
    margin: 10px;
}
// 贸易方式下拉：显示“代码 - 名称”，给足宽度避免换行
.trade_mode{
    width: 200px;
}
// 核放单号：输入框+识别图标一行，总宽度和旁边输入框一致
.check_no_box{
    display: flex;
    align-items: center;
    width:193px;
    .el-input{
        flex: 1;
    }
}
.check_no_icon{
    margin-left: 8px;
}
.form_item_60{
    width: 60%;
}
.IssueGoodsTipText{
    width: 100%;
    font-weight: bold;
    margin: 0px 5px;
    text-align: right;
    font-size: 10px;
}
.IssueGoodsExitRow{
    display: flex;
    justify-content:space-between;
    flex-direction: column;
}
/* 强制按钮文字折行 */
.goods-name-btn {
    word-break: break-all;
    white-space: normal;
    max-width: 200px; /* 限制最大宽度 */
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
}
.mini_button_text{
    padding: 3px 3px !important;

}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 5px;
}
.inventorySeach .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin-bottom: 3px !important;
    margin-right: 5px !important;
}
// 证件照片：预览用的 el-image，本体不显示，只借它的查看大图
.license_preview_hidden{
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 1px;
    height: 1px;
    overflow: hidden;
}
</style>
